/** Session cache so builder/routing can resolve campaign context without URL query params. */
const STORAGE_KEY_PREFIX = 'bss:instrument-workspace:'

export type InstrumentWorkspaceSession = {
  campaignId: string
  loiId: string
}

function storageKey(instrumentId: string): string {
  return `${STORAGE_KEY_PREFIX}${instrumentId}`
}

export function rememberInstrumentWorkspaceContext(
  instrumentId: string,
  context: InstrumentWorkspaceSession,
): void {
  // BFP-999 quick instruments have null/empty campaignId — no-op (no TypeError).
  const campaignId = String(context.campaignId ?? '').trim()
  if (!instrumentId.trim() || !campaignId) return
  try {
    sessionStorage.setItem(
      storageKey(instrumentId),
      JSON.stringify({
        campaignId,
        loiId: String(context.loiId ?? '').trim(),
      } satisfies InstrumentWorkspaceSession),
    )
  } catch {
    /* quota / private mode — best-effort */
  }
}

export function readInstrumentWorkspaceContext(
  instrumentId: string,
): InstrumentWorkspaceSession | null {
  try {
    const raw = sessionStorage.getItem(storageKey(instrumentId))
    if (!raw) return null
    const parsed = JSON.parse(raw) as InstrumentWorkspaceSession
    if (!parsed?.campaignId?.trim()) return null
    return {
      campaignId: parsed.campaignId.trim(),
      loiId: parsed.loiId?.trim() ?? '',
    }
  } catch {
    return null
  }
}
